/* This is used by NAVIGATION */
import React, { FC } from 'react'
import AuthenticationConnect, {
  ConnectorProps as AuthenticationProps,
} from 'connectors/Authentication'
import Register, { MODAL_NAME as RegisterName } from './Register'
import ResetPassword, { MODAL_NAME as ResetPasswordName } from './ResetPassword'
import PromptLogin, { MODAL_NAME as PromptLoginName } from './PromptLogin'
import Login, { MODAL_NAME as LoginName } from './Login'

const MODAL_NAMES = [RegisterName, ResetPasswordName, PromptLoginName, LoginName]
const MODAL_CONTENT = {
  [RegisterName]: Register,
  [ResetPasswordName]: ResetPassword,
  [PromptLoginName]: PromptLogin,
  [LoginName]: Login,
}

type AuthenticationModalsProps = AuthenticationProps

export type ModalComponentProps = {
  type: string
  closeModal: () => void
  loginModal: () => void
  registerModal: () => void
  resetPasswordModal: () => void
  updateSession: ({ cart, cookie, session }: { cart: number; cookie: any; session: any }) => void
}

const AuthenticationModals: FC<AuthenticationModalsProps> = (props) => {
  const { closeModal, isAuthenticated, modalData, name, openModal, updateSession } = props
  const { reloadPage } = modalData

  if (isAuthenticated || !MODAL_NAMES.includes(name)) {
    return null
  }

  const ModalComponent = MODAL_CONTENT[name]

  return (
    <ModalComponent
      type={name}
      closeModal={closeModal}
      loginModal={() => openModal(LoginName)}
      registerModal={() => openModal(RegisterName)}
      resetPasswordModal={() => openModal(ResetPasswordName)}
      updateSession={(data) => {
        updateSession(data)

        if (reloadPage) {
          // On Login - Reload the page
          window.location.reload()
        }
      }}
    />
  )
}

export default AuthenticationConnect(AuthenticationModals)
